import { FormLayoutTheme, multiVariantStyles, variants } from '../FormLayoutStyles.css';
import { baseTheme } from './FormLayoutBaseTheme.css';

const FormLayoutStableTheme: FormLayoutTheme = {
  baseTheme,
  multiVariantStyles,
  variants
};

/*******************
 * Exports
 *******************/

export { FormLayoutStableTheme };
